<template>
  <div>
    <b-card>
      <h5 class="mb-1">Настройки Боления</h5>
      <p class="text-muted mb-4">Управление интерактивным виджетом поддержки команд.</p>

      <div class="form-group mb-4">
        <label class="font-weight-bold">Выберите трансляцию</label>
        <b-form-select v-model="selectedWatchId" :options="watchOptions" @change="onWatchChange"></b-form-select>
      </div>

      <div v-if="selectedWatchId">
        <div class="mb-4">
          <b-form-checkbox v-model="isCheerEnabled" switch size="lg" @change="onToggle">
            Отображать виджет боления на трансляции
          </b-form-checkbox>
        </div>

        <div class="mb-4">
          <label class="font-weight-bold mb-2">Страны для боления</label>
          <div class="d-flex align-items-center mb-3">
            <b-form-select
              v-model="selectedCountryId"
              :options="countryOptions"
              class="mr-2"
            ></b-form-select>
            <b-button variant="success" size="sm" @click="addCountry" :disabled="!selectedCountryId">
              <i class="fa fa-plus"></i>
            </b-button>
          </div>

          <div v-if="selectedCountries.length" class="mb-3">
            <div v-for="(country, index) in selectedCountries" :key="country.id" class="d-flex align-items-center mb-2">
              <span class="mr-2 text-muted">{{ index + 1 }}.</span>
              <span class="mr-auto">{{ country.name }}</span>
              <b-button size="sm" variant="outline-danger" @click="removeCountry(index)">
                <i class="fa fa-times"></i>
              </b-button>
            </div>
          </div>

          <b-button variant="primary" @click="syncCheers" :disabled="isLoading || !selectedCountries.length">
            Синхронизировать
          </b-button>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import api from '@/api/api';

export default {
  name: "WatchFanSupport",
  data() {
    return {
      selectedWatchId: null,
      isCheerEnabled: false,
      countries: [],
      selectedCountries: [],
      selectedCountryId: null,
      isLoading: false,
    }
  },
  computed: {
    ...mapState('moduleWatch', ['watches', 'mainBanner']),
    allWatches() {
      const list = [...this.watches];
      if (this.mainBanner && !list.some(w => w.id === this.mainBanner.id)) {
        list.unshift(this.mainBanner);
      }
      return list;
    },
    watchOptions() {
      return [
        {value: null, text: 'Выберите трансляцию'},
        ...this.allWatches.map(w => {
          const name = w.title?.ru || w.youtube_link;
          const tournament = w.tournament?.name;
          return {
            value: w.id,
            text: tournament ? `${name} (${tournament})` : name
          };
        })
      ];
    },
    countryOptions() {
      const selectedIds = this.selectedCountries.map(c => c.id);
      return [
        {value: null, text: 'Выберите страну'},
        ...this.countries
          .filter(c => !selectedIds.includes(c.id))
          .map(c => ({value: c.id, text: c.name}))
      ];
    },
  },
  methods: {
    ...mapActions('moduleWatch', ['fetchWatches']),
    async loadCountries() {
      try {
        const response = await api.tournament.getCountries();
        this.countries = response.data.countries || [];
      } catch (error) {
        console.error('Error loading countries:', error);
      }
    },
    addCountry() {
      if (!this.selectedCountryId) return;
      const country = this.countries.find(c => c.id === this.selectedCountryId);
      if (country && !this.selectedCountries.some(c => c.id === country.id)) {
        this.selectedCountries.push(country);
      }
      this.selectedCountryId = null;
    },
    removeCountry(index) {
      this.selectedCountries.splice(index, 1);
    },
    async onWatchChange() {
      this.selectedCountries = [];
      this.isCheerEnabled = false;
      if (!this.selectedWatchId) return;

      const watch = this.allWatches.find(w => w.id === this.selectedWatchId);
      this.isCheerEnabled = watch?.is_cheer_enabled || false;

      try {
        const response = await api.cheers.index(this.selectedWatchId);
        const cheers = response.data.cheers || response.data.data || [];
        this.selectedCountries = cheers.map(c => {
          const country = this.countries.find(ct => ct.id === c.country_id);
          return country || { id: c.country_id, name: c.country?.name || `Country #${c.country_id}` };
        });
      } catch (error) {
        console.error('Error loading cheers:', error);
      }
    },
    async syncCheers() {
      this.isLoading = true;
      try {
        const countryIds = this.selectedCountries.map(c => c.id);
        await api.cheers.sync(this.selectedWatchId, {country_ids: countryIds});
        this.$toast.success('Синхронизировано', {position: 'top-right', timeout: 2000});
      } catch (error) {
        console.error('Error syncing cheers:', error);
        this.$toast.error('Ошибка синхронизации', {position: 'top-right'});
      } finally {
        this.isLoading = false;
      }
    },
    async onToggle() {
      try {
        await api.cheers.toggle(this.selectedWatchId);
        this.$toast.success(
          this.isCheerEnabled ? 'Виджет боления включён' : 'Виджет боления выключен',
          {position: 'top-right', timeout: 2000}
        );
      } catch (error) {
        console.error('Error toggling cheers:', error);
        this.isCheerEnabled = !this.isCheerEnabled;
        this.$toast.error('Ошибка переключения', {position: 'top-right'});
      }
    },
  },
  created() {
    this.fetchWatches();
    this.loadCountries();
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 1rem;
}
</style>
